import {
  type MantineThemeOverride,
  Tooltip,
  getDefaultZIndex,
} from "@mantine/core";

import { PORTAL_CONTAINER_ID } from "../PortalContainer/constants";

import TooltipStyles from "./Tooltip.module.css";

export const tooltipOverrides: MantineThemeOverride["components"] = {
  Tooltip: Tooltip.extend({
    defaultProps: {
      arrowSize: 10,
      withArrow: true,
      withinPortal: true,
      // Mantine puts Tooltip, Popover and Menu on the same "popover" tier, so a
      // tooltip ties with them and loses on portal DOM order. +1 keeps it in its
      // tier but always renders above same-tier overlays.
      zIndex: getDefaultZIndex("popover") + 1,
      portalProps: {
        target: `#${PORTAL_CONTAINER_ID}`,
      },
      transitionProps: {
        transition: "fade",
        duration: 200,
      },
      // Without a closeDelay, floating-ui closes the tooltip the instant the
      // pointer leaves the trigger (0ms default), which is almost always
      // before it can reach the tooltip itself across the gap left by
      // `offset`/the arrow -- making the content effectively impossible to
      // hover over, even though floating-ui does support it once the pointer
      // arrives (WCAG 1.4.13 Content on Hover or Focus -- confirmed live:
      // moving the pointer from the trigger to the tooltip along a realistic
      // path closed it before arrival). 150ms matches this app's own
      // HoverCard, which solves the same gap with the same value.
      closeDelay: 150,
      events: {
        hover: true,
        focus: true,
        touch: true,
      },
      color: "tooltip-background",
    },
    classNames: {
      tooltip: TooltipStyles.tooltip,
      arrow: TooltipStyles.arrow,
    },
  }),
};
